import React from 'react'
import Pos from './pos'

type PosDrawerProps = {
  propertyId: string
  closeDrawer: () => void
  billId?: string
}

export default function PosDrawer(props: PosDrawerProps) {
  const { propertyId, billId, closeDrawer } = props

  return (
    <Pos
      propertyId={propertyId}
      billId={billId}
      onSave={(success) => {
        if (success) {
          closeDrawer()
        }
      }}
      onCancel={closeDrawer}
      asPage={false}
    />
  )
}
